import { createAction, createReducer } from 'redux-act';

import { Tab } from '@sravni/ugc/lib/specialOffers/types';

export interface IState {
  tabs: Tab[];
}

const initialState: IState = {
  tabs: [],
};

export const setSpecialOffersPopupTabs = createAction<Tab[]>('specialOffers/tabs/set');

const specialOffers = createReducer<IState>({}, initialState).on(setSpecialOffersPopupTabs, (state, payload) => {
  return {
    ...state,
    tabs: payload,
  };
});

export default specialOffers;
